import horizontal from './horizontal.vue';
import vertical from './vertical.vue';
import subvertical from './subvertical.vue';

export default null;
export {
    horizontal,
    vertical,
    subvertical
};